import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Login = () => {
  return (
    <div className="min-h-screen" data-testid="login-page">
      <Header />
      <div className="pt-20 min-h-[60vh] flex items-center justify-center">
        <div className="container text-center">
          <h1 className="text-4xl md:text-5xl font-serif text-primary mb-4">Login</h1>
          <p className="text-muted-foreground text-lg">LMS Platform Login - Coming Soon</p>
          <p className="text-muted-foreground text-sm mt-2">Email or Mobile OTP authentication</p>
        </div>
      </div>
      <Footer onStartQuiz={() => {}} />
    </div>
  );
};

export default Login;
